import { Injectable } from '@angular/core';
import { IPSAuthenticationService, IPSTenantKeyService } from '@ips/common-angular';

@Injectable({
  providedIn: 'root'
})
export class ExternalUserCheckService {
  
  isUserLinkedToAccount: boolean = false; //true when logged in user does not have any account associated.  
  selectedTenant?: string | null;

  constructor(
    private readonly authService: IPSAuthenticationService,
    private readonly tenantKeyService: IPSTenantKeyService
  ) { }

  isExternalUser(): boolean {
    this.authService.currentUser.forEach(user => {
      this.tenantKeyService.getTenantKey().subscribe((selectedTenant) => {
        this.selectedTenant = selectedTenant;
      });
      // this.loggedinUserName = user.definition?.firstName + ' ' + user.definition?.lastName;
      // this.loggedinUserEmail = user.definition?.email ?? '';
      // this.loggedinUserPhone = user.definition?.phone ?? '';
      let organizationValue: any = user?.definition?.attributes?.find(item => item?.key === 'organization' && item?.tenantKey?.toLowerCase() === this.selectedTenant?.toLowerCase());
      if (organizationValue?.value) { 
        this.isUserLinkedToAccount = true;
      } else {
        this.isUserLinkedToAccount = false;
      }
    });
    return this.isUserLinkedToAccount;
  }
  
}
